import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

/**Import Assets */
import styles from "./styles/ProtectedLayout.module.scss";
// import cssStyles from './styles/notification.module.css';

/**Import Custom Component */
import { WEB_ROUTES } from "../../constants";
import { baseRoute } from "../../Helper";
import Navbar from "./Navbar";

// Icons
import { FaUser } from "react-icons/fa";
import { IoIosSettings } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5";
import {
  MdBatchPrediction,
  MdCastForEducation,
  MdDashboard,
  MdFolderSpecial,
  MdHotelClass,
  MdOutlineHotelClass,
  MdPayments
} from "react-icons/md";
import { SiGoogleclassroom, SiReasonstudios } from "react-icons/si";
import { TbCategoryFilled, TbLogout2, TbTransactionDollar } from "react-icons/tb";
import { VscGitPullRequestGoToChanges } from "react-icons/vsc";
import { removeToken } from "../../Data/services/localStorageService";
import Toast from "../../Hooks/useToast";
import LogoutModal from "../Modals/LogoutModal";

export default function ProtectedLayout({
  isSearchBar,
  isSettingButton,
  selectedRoute,
  children,
}) {
  const [collapsed, setCollapsed] = useState(window.innerWidth > 991);

  const [logoutModal, setLogoutModal] = useState(false);

  const navigate = useNavigate();
  // todo: menu
  const items = [
    {
      label: "Dashboard",
      icon: <MdDashboard />,
    },
    {
      label: "User Management",
      icon: <FaUser />,
    },
    // {
    //   label: "Post Management",
    //   icon: <BsPostageFill />,
    // },
    // {
    //   label: "Group Management",
    //   icon: <MdGroup />,
    // },
    // {
    //   label: "Event Management",
    //   icon: <MdOutlineEventNote />,
    // },
    // {
    //   label: "Post Report Management",
    //   icon: <MdReport />,
    // },
    {
      label: "Profile Update Requests",
      icon: <VscGitPullRequestGoToChanges />,
    },
    {
      label: "Nurse Documents",
      icon: <IoDocumentTextOutline  />,
    },
    {
      label: "Training Category",
      icon: <TbCategoryFilled />,
    },
    {
      label: "Training Management",
      icon: <MdCastForEducation />,
    },
    {
      label: "Training Batches",
      icon: <MdBatchPrediction />,
    },
    {
      label: "Training Classes",
      icon: <SiGoogleclassroom />,
    },
    {
      label: "Service Types Management",
      icon: <SiReasonstudios />,
    },
    {
      label: "Specialities Management",
      icon: <MdFolderSpecial />,
    },
    {
      label: "Class Enrollment",
      icon: <MdOutlineHotelClass />,
    },
    {
      label: "Training Enrollment",
      icon: <MdHotelClass />,
    },
    {
      label: "Subscribers",
      icon: <MdPayments />,
    },
    {
      label: "Transactions",
      icon: <TbTransactionDollar />,
    },
    {
      label: "Settings",
      icon: <IoIosSettings />,
    },
  ];

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  const handleMenuClose = () => {
    setCollapsed(false);
  };

  const handleViewProfile = () => {
    navigate(baseRoute(WEB_ROUTES.PROFILE));
  };

  const handleLogoutModalOpen = () => {
    setLogoutModal(true);
  };

  const handleLogoutModalClose = () => {
    setLogoutModal(false);
  };

  const handleLogout = () => {
    try {
      removeToken();
      navigate("/account");
      window.location.reload();
      Toast("Logged Out Successfully", "success");
    } catch {
      Toast("An error occurred during log out", "error");
    }
  };

  return (
    <div className={styles.ProtectedLayout}>
      <div
        className={collapsed ? styles.background : ""}
        onClick={handleMenuClose}
      ></div>
      <div
        className={`${styles.menu} ${
          collapsed ? `${styles.collapsed} visible` : styles.notCollapsed
        }`}
        id="sider"
      >
        <div
          className={`${styles.logo} ${
            !collapsed ? styles.notCollapsed : ""
          } w-50 add-image`}
          to={`${process.env.REACT_APP_DOMAIN_DIR}/dashboard`}
        >
          <img
            src={collapsed ? "/images/Logo.png" : "/images/favicon.png"} //todo:
            alt="Logo"
            className={
              collapsed ? styles.imageCollapsed : styles.imageNotCollapsed
            }
          />
          {/* {collapsed && <h5 className=""></h5>} */}
        </div>

        {/* <div className={`${styles.drawer} ${collapsed ? styles.collapsed : ''}`}>

                    <span onClick={handleToggle}>
                        <BiLogOut />
                    </span>
                </div> */}

        {items.map(({ icon, label }, index) => {
          return (
            <Link
              to={`${process.env.REACT_APP_DOMAIN_DIR}/${label
                .toLowerCase()
                .replace(/[^A-Z0-9]/gi, "-")}`}
              className={`${styles.item} ${
                index === selectedRoute ? styles.active : ""
              }`}
              key={index}
            >
              <span style={{ fontSize: "20px", display: "flex" }}>
                {" "}
                {icon}{" "}
              </span>
              {collapsed ? <p>{label}</p> : ""}
            </Link>
          );
        })}
        <Link
          className={styles.item}
          onClick={handleLogoutModalOpen}
          // onClick={() => submit("Confirm Logout", "Are you sure you want to logout?", () => handleLogout())}
        >
          {/* <img src={logout} alt="Icon1" width={20} height={20} /> */}
          <span style={{ fontSize: "20px", display: "flex" }}>
            {" "}
            <TbLogout2 />{" "}
          </span>
          {collapsed ? <p>Logout</p> : ""}
        </Link>
      </div>
      <div className={styles.routeContent}>
        {logoutModal ? (
          <LogoutModal
            handleLogoutModalClose={handleLogoutModalClose}
            data={""}
            onLogout={handleLogout}
          />
        ) : null}
        <Navbar
          isSearchBar={isSearchBar}
          isSettingButton={isSettingButton}
          handleToggle={handleToggle}
        />
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}
